var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeuArbre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Feu",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17 17",
    style: {
      enableBackground: "new 0 0 17 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.stfeua0{fill:#616173;}\r\n\t.stfeua1{fill:#616173;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.stfeua2{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_1_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.3,
    y: 1.7,
    className: "stfeua0",
    width: 7.1,
    height: 13.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "stfeua1",
    d: "M13.1,1.8H4.4l0,0c0-0.9,0.7-1.6,1.6-1.6h5.5C12.4,0.1,13.1,0.9,13.1,1.8L13.1,1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stfeua1",
    d: "M4.4,15.2h8.7v0.1c0,0.9-0.7,1.6-1.6,1.6H6C5.1,16.9,4.4,16.2,4.4,15.2L4.4,15.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "stfeua2",
    cx: 8.8,
    cy: 4.4,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "stfeua2",
    cx: 8.8,
    cy: 8.6,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "stfeua2",
    cx: 8.7,
    cy: 12.7,
    r: 1.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeuArbre);
export default __webpack_public_path__ + "static/media/Feu-arbre.294fa1733b6835cabd5fd904bccaeab7.svg";
export { ForwardRef as ReactComponent };